import { all, spawn } from 'redux-saga/effects';
import * as accountSagas from '../features/account/accountSaga';
import * as emailFormSagas from '../features/emailForm/emailFormSaga';
import * as bankDetailsFormSagas from '../features/bankDetailsForm/bankDetailsFormSaga';
import * as panDetailsFormSagas from '../features/panDetailsForm/panDetailsFormSaga';
import * as personalDetailsFormSagas from '../features/personalDetailsForm/personalDetailsFormSaga';
import * as nomineeDetailsFormSagas from '../features/nomineeDetailsForm/nomineeDetailsFormSaga';
import * as digioFormSagas from '../features/digioForm/digioFormSaga';
import * as fnoActivationFormSagas from '../features/fnoActivationForm/fnoActivationFormSaga';
import * as bankDetailsSagas from '../features/bankDetailsForm/bankDetailsSaga';
import * as modificationSagas from '../features/modification/redux/modificationSaga'

export default function* rootSaga() {
  yield all([
    ...Object.values(accountSagas),
    ...Object.values(emailFormSagas),
    ...Object.values(bankDetailsFormSagas),
    ...Object.values(panDetailsFormSagas),
    ...Object.values(personalDetailsFormSagas),
    ...Object.values(digioFormSagas),
    ...Object.values(nomineeDetailsFormSagas),
    ...Object.values(fnoActivationFormSagas),
    ...Object.values(bankDetailsSagas),
    ...Object.values(modificationSagas),
  ].map(spawn));
}
